import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const CreateSubTaskFlow = createAsyncThunk(
  "CreateSubTaskFlow",
  async (task, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubTaskFlow/CreateSubTaskFlow",
        {
          taskGuid: task.taskGuid,
          uS_UserList: task.uS_UserList,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "CreateSubTaskFlow");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AssigningSubTask = createAsyncThunk(
  "AssigningSubTask",
  async (task, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubTaskFlow/AssigningSubTask",
        {
          taskGUID: task.taskGUID,
          issiningMainTask: task.issiningMainTask,
          userGuid: task.userGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "CreateSubTaskFlow");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSubTaskById = createAsyncThunk(
  "GetSubTaskById",
  async (subTaskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/SubTaskFlow/GetSubTaskById", {
        subTaskFlowGUID: subTaskFlowGUID,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetSubTaskById");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const CreateSubTaskeByFlowAndUser = createAsyncThunk(
  "SubTaskFlow/CreateSubTaskeByFlowAndUser",
  async (task, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubTaskFlow/CreateSubTaskeByFlowAndUser",
        {
          taskGuidList: task.taskGuidList,
          uS_UserList: task.uS_UserList,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "CreateSubTaskFlow");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ChangeStatustSubTaskById = createAsyncThunk(
  "ChangeStatustSubTaskById",
  async (subTaskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubTaskFlow/ChangeStatustSubTaskById",
        {
          subTaskFlowGUID: subTaskFlowGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetSubTaskById");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ChangeStatustToAllTasksByUserId = createAsyncThunk(
  "ChangeStatustToAllTasksByUserId",
  async (subTaskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubTaskFlow/ChangeStatustToAllTasksByUserId",
        {}
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetSubTaskById");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SubTaskFlow = createSlice({
  name: "SubTaskFlow",
  initialState: {
    SubTaskFlow: {},
    loadingSubTaskFlow: false,
    errorSubTaskFlow: null,
    //----------------------------------------------------
    AssigningTask: {},
    loadingAssigningTask: false,
    errorAssigningTask: null,
    //----------------------------------------------------
    subTaskFlowByGUID: {},
    loadingsubTaskFlowByGUID: false,
    errorsubTaskFlowByGUID: null,
    //-----------------------CreateSubTaskeByFlowAndUser-----------------------------
    subTaskFlowEval: {},
    loadingsubTaskFlowEval: false,
    errorsubTaskFlowEval: null,
    //-----------------------ChangeStatustSubTaskById-----------------------------
    subTaskStatus: {},
    loadingsubTaskStatus: false,
    errorsubTaskStatus: null,
    //-----------------------ChangeStatustSubTaskById-----------------------------
    AllsubTaskStatus: {},
    loadingAllsubTaskStatus: false,
    errorAllsubTaskStatus: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CreateSubTaskFlow.pending, (state, action) => {
        state.loadingSubTaskFlow = true;
        state.SubTaskFlow = action.payload;
        state.errorSubTaskFlow = null;
      })
      .addCase(CreateSubTaskFlow.fulfilled, (state, action) => {
        state.loadingSubTaskFlow = false;
        state.SubTaskFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(CreateSubTaskFlow.rejected, (state, action) => {
        state.loadingSubTaskFlow = false;
        state.errorSubTaskFlow = action.payload;
      });
    //--------------------------------------------

    builder
      .addCase(AssigningSubTask.pending, (state, action) => {
        state.loadingAssigningTask = true;
        state.AssigningTask = action.payload;
        state.errorAssigningTask = null;
      })
      .addCase(AssigningSubTask.fulfilled, (state, action) => {
        state.loadingAssigningTask = false;
        state.AssigningTask = action.payload; // Assuming payload has the desired data
      })
      .addCase(AssigningSubTask.rejected, (state, action) => {
        state.loadingAssigningTask = false;
        state.errorAssigningTask = action.payload;
      });

    //--------------------------------------------

    builder
      .addCase(GetSubTaskById.pending, (state, action) => {
        state.loadingsubTaskFlowByGUID = true;
        state.subTaskFlowByGUID = action.payload;
        state.errorsubTaskFlowByGUID = null;
      })
      .addCase(GetSubTaskById.fulfilled, (state, action) => {
        state.loadingsubTaskFlowByGUID = false;
        state.subTaskFlowByGUID = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSubTaskById.rejected, (state, action) => {
        state.loadingsubTaskFlowByGUID = false;
        state.errorsubTaskFlowByGUID = action.payload;
      });

    //--------------------------------------------

    builder
      .addCase(CreateSubTaskeByFlowAndUser.pending, (state, action) => {
        state.loadingsubTaskFlowEval = true;
        state.subTaskFlowEval = action.payload;
        state.errorsubTaskFlowEval = null;
      })
      .addCase(CreateSubTaskeByFlowAndUser.fulfilled, (state, action) => {
        state.loadingsubTaskFlowEval = false;
        state.subTaskFlowEval = action.payload; // Assuming payload has the desired data
      })
      .addCase(CreateSubTaskeByFlowAndUser.rejected, (state, action) => {
        state.loadingsubTaskFlowEval = false;
        state.errorsubTaskFlowEval = action.payload;
      });

    //--------------------------------------------

    builder
      .addCase(ChangeStatustSubTaskById.pending, (state, action) => {
        state.loadingsubTaskStatus = true;
        state.subTaskStatus = action.payload;
        state.errorsubTaskStatus = null;
      })
      .addCase(ChangeStatustSubTaskById.fulfilled, (state, action) => {
        state.loadingsubTaskStatus = false;
        state.subTaskStatus = action.payload; // Assuming payload has the desired data
      })
      .addCase(ChangeStatustSubTaskById.rejected, (state, action) => {
        state.loadingsubTaskStatus = false;
        state.errorsubTaskStatus = action.payload;
      });

        //--------------------------------------------

    builder
    .addCase(ChangeStatustToAllTasksByUserId.pending, (state, action) => {
      state.loadingAllsubTaskStatus = true;
      state.AllsubTaskStatus = action.payload;
      state.errorAllsubTaskStatus = null;
    })
    .addCase(ChangeStatustToAllTasksByUserId.fulfilled, (state, action) => {
      state.loadingAllsubTaskStatus = false;
      state.AllsubTaskStatus = action.payload; // Assuming payload has the desired data
    })
    .addCase(ChangeStatustToAllTasksByUserId.rejected, (state, action) => {
      state.loadingAllsubTaskStatus = false;
      state.errorAllsubTaskStatus = action.payload;
    });
  },
});

export default SubTaskFlow.reducer;
